const authUrl = process.env.SERVICE_HOST_FUSIONAUTH
const accountsApiUrl = process.env.SERVICE_HOST_ACCOUNTS
const docservApiUrl = process.env.SERVICE_HOST_DOCSERV
const homeApiUrl = process.env.SERVICE_HOST_HOME
const locationApiUrl = process.env.SERVICE_HOST_LOCATIONS
const paymentsMethodsUrl = process.env.SERVICE_HOST_PAYMETHODS || ''
const bstockCreditsUrl = process.env.SERVICE_HOST_BSTOCK_CREDIT
const ordersApiUrl = process.env.SERVICE_HOST_ORDERS
const clientId = process.env.FA_CLIENT_ID
const bridge = process.env.SERVICE_HOST_BRIDGE
const savedSearchApiUrl = process.env.SERVICE_HOST_SAVED_SEARCH
const searchApiUrl = process.env.SERVICE_HOST_SEARCH

// set notify api url by environment injection OR use known b-stock dev ops hostname
const notificationsUrl = process.env.SERVICE_HOST_NOTIFICATIONS
// relates to what type of marketing source is being applied for (acceptMarketingSolicitation)
const marketingTypeId = process.env.NOTIFICATION_TYPE_ID
// Fallback when NOTIFICATION_TYPE_ID undefined. Can occur during local developments so just helpful. Does not need to be devops reported
const marketingEmailTypeName =
  process.env.NOTIFICATION_EMAIL_ME_ABOUT_AUCTIONS || 'EMAIL_ME_ABOUT_AUCTIONS'

const oauth2 = `${authUrl}/oauth2`

const people = `${accountsApiUrl}/v1/people`
const peopleId = `${people}/:id`

const accounts = `${accountsApiUrl}/v1/accounts`
const accountsId = `${accountsApiUrl}/v1/accounts/:id`
const accountsIdRole = `${accountsApiUrl}/v1/accounts/:id/roles/:role`

const docserv = `${docservApiUrl}/v1/documents`
const locations = `${locationApiUrl}/locations`
const exemptionReqs = `${locationApiUrl}/exemption-requirements`
const home = homeApiUrl
const auctionsList = `${homeApiUrl}/all-auctions/`
const allMarketplaces = `${homeApiUrl}/marketplaces/`

const sites = `${accountsApiUrl}/v1/sites`

const accountTerms = `${accountsApiUrl}/v1/terms/:id`

const savedSearch = `${savedSearchApiUrl}/v1/saved-search`
const searchAllListings = `${searchApiUrl}/all-listings`

export default {
  portalPaths: {
    home,
    auctionsList,
    allMarketplaces,
  },
  oauth2: {
    authorize: `${oauth2}/authorize`,
    // Completes a passwordless login started by the account service (FP-3569):
    // `${passwordless}/{code}` behaves like a credentialed authorize request.
    passwordless: `${oauth2}/passwordless`,
    forgot: `${authUrl}/password/forgot`,
  },
  salesforce: {
    authorize: process.env.SALESFORCE_AUTH_URL,
    clientId: process.env.SALESFORCE_AUTH_CLIENT_ID,
  },

  auth: {
    clientId,
  },

  corpSite: {
    terms: 'https://bstock.com/terms-of-use',
    buyerTermsConditions:
      'https://bstock.com/b-stock-solutions-buyer-terms-and-conditions/',
    privacyPolicy: 'https://bstock.com/privacy-policy/',
  },

  notifications: {
    marketingEmailTypeName, // relates to getEmailNotificationTypeId()
    marketingTypeId, // relates to acceptMarketingSolicitation:boolean and updateMarketingPreference()
    preferences: `${notificationsUrl}/preferences`,
    types: `${notificationsUrl}/types`,
    markets: `${notificationsUrl}/markets`,
    favoriteMarkets: `${notificationsUrl}/favorite-markets`,
  },

  people: {
    default: people,
    forgotPassword: `${people}/forgot-password`,
    checkExisting: `${people}/check-existing`,

    id: {
      default: peopleId,
      resendValidationEmail: `${peopleId}/resend-validation-email`,
      verifyEmail: `${peopleId}/verify-email`,
      verifyEmailCode: `${peopleId}/verify-email-code`,
    },
  },

  bridge: {
    uaExists: `${bridge}/ua-exists`,
    mageExists: `${bridge}/mage-exists`,
    accountsMigrate: `${bridge}/accounts/migrate`,
  },

  accounts: {
    default: accounts,
    id: {
      default: accountsId,
      roles: {
        accountsIdRole: {
          default: accountsIdRole,
          onboarding: `${accountsIdRole}/onboarding`,
        },
      },
      requirements: {
        siteAbb: `${accounts}/:id/requirements/:siteAbb`,
      },
    },
    sites: {
      getSites: sites,
      addMarketplace: `${accounts}/:id/sites`,
    },
  },

  terms: {
    accepted: accountTerms,
    accept: `${accountTerms}/:policy/accept`,
  },

  locations: {
    default: locations,
    document: `${locationApiUrl}/documents`,
    documentById: `${locationApiUrl}/documents/:id`,
    taxIdValidate: `${locationApiUrl}/documents/validate/:state`,
    validate: `${locationApiUrl}/addresses/validate`,
    id: {
      default: `${locations}/:id`,
    },
    exemptionReqs: {
      country: `${exemptionReqs}/:country`,
      countryRegion: `${exemptionReqs}/:country/:region`,
    },
    generateResaleCertificate: `${locationApiUrl}/documents/tax-document`,
    countries: `${locationApiUrl}/countries`,
    exemption: `${locationApiUrl}/exemptions`,
    exemptionByJurisdiction: `${locationApiUrl}/exemptions/:accountId/:country/:region`,
  },

  docserv: {
    default: docserv,
  },

  payments: {
    entities: `${paymentsMethodsUrl}/entities/:entityId/methods`,
    methods: `${paymentsMethodsUrl}/methods/:id`,
    makePrimary: `${paymentsMethodsUrl}/methods/:id/make-primary`,
    credit: {
      balance: `${bstockCreditsUrl}/erp/credits-balance/:accountId`,
    },
  },

  savedSearch: {
    default: savedSearch,
    id: {
      default: `${savedSearch}/:id`,
    },
  },

  search: {
    allListings: searchAllListings,
  },

  netTermsBalance: {
    startQualification: `${paymentsMethodsUrl}/balance/start-qualification`,
    getBalancePortalLink: `${paymentsMethodsUrl}/balance/:balanceBuyerId/balance-portal-link`,
    searchInvoices: `${paymentsMethodsUrl}/balance/search-invoices/:balanceBuyerId`,
  },

  balance: {
    paymentMethodToken: `${paymentsMethodsUrl}/balance/:buyerAccountId/token`,
  },

  orders: {
    assignedAutopayOrders: `${ordersApiUrl}/v1/orders/assigned-autopay-orders`,
  },

  serviceHosts: {
    fusionauth: authUrl,
    accounts: accountsApiUrl,
    paymentMethods: paymentsMethodsUrl,
    search: searchApiUrl,
  },
} as const
